<template>
  <b-row>
    <b-col md="12">
      <card class="stacked-form">
        <l-progress v-if="isLoading" :value="100" :height="20" class="mb-2" type="info" :animated="true" :striped="true"></l-progress>
        <div class="row mb-5">
          <div class="col-md-6">
              <fg-input label="Dibuat Oleh">
                <p>{{model.createdBy}}</p>
              </fg-input>
              <fg-input label="Diperbaharui Oleh">
                <p>{{model.lastUpdatedBy}}</p>
              </fg-input>
              <fg-input label="Supllier">
                <p>{{model.supplier}}</p>
              </fg-input>
              <fg-input label="Tanggal Pembelian">
                <p>{{model.poDate}}</p>
              </fg-input>
              <fg-input label="Status">
                <p><b-badge :variant="getStatusColor(model.status)">{{getStatus(model.status)}}</b-badge></p>
              </fg-input>
          </div>
          <div class="col-md-6">
              <fg-input label="Total Item Dipesan">
                <p>
                  <strong>{{totalItemOrdered}}</strong>
                </p>
              </fg-input>
              <!-- <fg-input label="Total Item Diterima">
                <p>
                  <strong>{{totalItemAccepted}}</strong>
                </p>
              </fg-input> -->
              <fg-input label="Total Harga">
                <p>
                  <strong>{{formatNumber(total)}}</strong>
                </p>
              </fg-input>
          </div>
        </div>
        <b-row>
          <b-col md="6">
            <h4>Barang yang Dipesan</h4>
          </b-col>
          <b-col md="6" class="text-right">
            <b-button variant="primary"  v-if="model.status === 0" class="mt-4" :to="'/pembelian/' + $route.params.id + '/edit'">
              <font-awesome-icon icon="plus"/> Tambah Item
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12" v-if="supplierProductPo.product_color !== null" v-for="supplierProductPo in model.supplierPoProduct" :key="supplierProductPo.id">
            <b-row class="mt-3">
              <b-col md="6" class="mb-3">
                <strong>{{supplierProductPo.product_color.product_categories.category.name}} {{supplierProductPo.product_color.color.name}}</strong>
                <b-button size="sm" variant="danger" v-if="model.status === 0" @click="doDelete(supplierProductPo.product_color_id)">
                  <font-awesome-icon icon="trash"></font-awesome-icon>
                </b-button>
              </b-col>
            </b-row>
            <table class="table table-bordered table-striped">
              <tr>
                <th width="100">Varian</th>
                <th width="100">Stock</th>
                <th width="100">Stock Saat ini</th>
                <th width="200">Memesan</th>
                <th width="250">Harga Modal</th>
                <th>Total</th>
              </tr>
              <tr v-for="product in model.poProductSizes" :key="product.id">
                <template v-if="product.product_color_id == supplierProductPo.product_color.id">
                  <td>{{product.product_size.size.name}}</td>
                  <td>{{product.product_size.stock}}</td>
                  <td>{{product.current_stock}}</td>
                  <td>
                    <template v-if="model.status === 0">
                      <b-row>
                        <b-col md="8">
                          <b-form-input type="number" placeholder="Masukkan jumlah pesanan" v-model="product.ordered"></b-form-input>
                        </b-col>
                        <b-col md="2">
                          <b-button size="sm" variant="success" v-if="model.status === 0" @click="doUpdateOrder(product.ordered,product.id)">
                            <font-awesome-icon v-if="isLoadingUpdateOrdered" icon="spinner" spin></font-awesome-icon>
                            <font-awesome-icon v-else icon="check"></font-awesome-icon>
                          </b-button>
                        </b-col>
                      </b-row>
                    </template>
                    <template v-else>{{product.ordered}}</template>
                  </td>
                  <td>{{formatNumber(product.product_size.capital_price)}}</td>
                  <td>{{formatNumber(product.product_size.capital_price * product.ordered)}}</td>
                </template>
              </tr>
            </table>
          </b-col>
        </b-row>
        <back-button/>
      </card>
    </b-col>
    <div class="bubble-info">
      <b-button type="submit" v-if="model.status === 0" @click="doSubmit" variant="primary" class="float-right"><font-awesome-icon v-if="isLoading" icon="spinner" spin /><font-awesome-icon v-else icon="save"/> Perbarui</b-button>
    </div>
    <b-modal ref="modal-history"  centered hide-footer :title="'Tambah History'">
      <form v-on:submit.prevent="doSubmitLog">
        <label for="">Diterima</label>
        <b-form-input type="number" v-model="modelLog.accepted" class="mb-3"></b-form-input>
        <div class="form-group">
          <label>Tanggal Diterima</label>
          <el-date-picker v-model="fakeModelLog.date" placeholder="Masukkan Tanggal diterima" ></el-date-picker>
          <input v-model="modelLog.date" type="hidden" name="date"/>
        </div>
        <b-button :variant="'warning'" class="float-left" @click="hideModal"><font-awesome-icon :icon="'times'"/> Canle</b-button>
        <save-data-button :disabled="saveButtonData.isLoading" :is-create="$route.params.id !== undefined" :state="saveButtonData.isLoading && saveButtonData.state === 1 ? 2 : saveButtonData.state" :is-loading="saveButtonData.isLoading"/>
      </form>
    </b-modal>
  </b-row>
</template>

<script>
  import { DatePicker, Switch } from 'element-ui'
  import {Progress as LProgress} from 'src/components/index'
  import Edit from '@/components/Buttons/Edit'
  import Back from '@/components/Buttons/Back'
  import SaveData from '@/components/Buttons/SaveData'

  export default {
    components: {
      SaveDataButton: SaveData,
      LProgress,
      [DatePicker.name]: DatePicker,
      EditButton: Edit,
      BackButton: Back,
      LSwitch: Switch
    },
    data () {
      return {
        isLoading: false,
        isLoadingUpdateOrdered: false,
        visible: true,
        apiUrl: {
          supplierPo: window.AppConfig.apiUrl + 'supplier-po',
          supplierPoLog: window.AppConfig.apiUrl + 'supplier-po-product'
        },
        saveButtonData: {
          isLoading: false,
          state: 1
        },
        modelLog: {
          supplier_po_product_id: null,
          ordered: 0,
          date: null,
          accepted: 0
        },
        fakeModelLog: {
          date: null
        },
        subTotal: 0,
        total: 0,
        totalItemOrdered: 0,
        totalItemAccepted: 0,
        model: {
          createdBy: null,
          name: '',
          lastUpdatedBy: null,
          supplier: null,
          poDate: null,
          status: null,
          supplierPoProduct: [],
          poProductSizes: []
        }
      }
    },
    watch: {
      '$route.params.uuid': function (val) {
        this.getDetail()
      },
      'fakeModelLog.date' (value) {
        this.modelLog.date = value !== null ? this.$moment(value).format('YYYY-MM-DD') : null
      }
    },
    mounted () {
      this.getDetail()
    },
    methods: {
      showModalHistory (value) {
        this.modelLog.supplier_po_product_id = value.id
        this.modelLog.ordered = value.ordered
        this.$refs['modal-history'].show()
      },
      hideModal () {
        this.$refs['modal-history'].hide()
      },
      getDetail () {
        this.isLoading = true
        this.$http.get(this.apiUrl.supplierPo + '/' + this.$route.params.id)
        .then(response => {
          this.model.createdBy = response.data.created_by.name
          this.model.lastUpdatedBy = response.data.last_updated_by.name
          this.model.supplier = response.data.supplier.name
          this.model.poDate = response.data.po_date
          this.model.status = response.data.status
          this.model.poProductSizes = response.data.po_product_sizes
          this.model.supplierPoProduct = response.data.supplier_po_product
          this.total = 0
          this.totalItemOrdered = 0
          this.model.supplierPoProduct.forEach(supplierProductPo => {
            supplierProductPo.product_color.product_size.forEach(productColor => {
              this.totalItemOrdered += productColor.ordered
              this.total += productColor.product_size.capital_price * productColor.ordered
            })
          })
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          this.$store.dispatch('notification/error', error)
          // this.$router.push('/notfound')
        })
      },
      doSubmitLog () {
        this.$swal({
          title: 'Apakah anda sudah yakin?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Ya, Sudah',
          cancelButtonText: 'Tidak, belum',
          confirmButtonClass: 'btn btn-danger mr-3',
          cancelButtonClass: 'btn btn-default',
          buttonsStyling: false
        }).then(result => {
          if (result) {
            this.$http.post(this.apiUrl.supplierPoLog, this.modelLog).then(response => {
              this.isLoading = false
              this.modelLog.accepted = 0
              this.modelLog.date = null
              this.fakeModelLog.date = null
              this.hideModal()
              this.getDetail()
              this.$store.dispatch('notification/success', 'History berhasil ditambahkan.')
            }).catch(error => {
              this.saveButtonData.isLoading = false
              this.$store.dispatch('notification/error', error)
            })
          }
        })
      },
      doSubmit () {
        this.$swal({
          title: 'Apakah anda sudah yakin?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Ya, Sudah',
          cancelButtonText: 'Tidak, belum',
          confirmButtonClass: 'btn btn-success mr-3',
          cancelButtonClass: 'btn btn-default',
          buttonsStyling: false
        }).then(result => {
          if (result) {
            let products = []
            this.model.supplierPoProduct.forEach(supplierPoProduct => {
              supplierPoProduct.product_color.product_size.forEach(productColor => {
                products.push({
                  productSize: productColor.product_size_id,
                  product_color_id: productColor.product_color_id,
                  ordered: productColor.ordered
                })
              })
            })
            this.$http.patch(this.apiUrl.supplierPo + '/' + this.$route.params.id, {
              status: 1,
              products: products
            }).then(response => {
              this.isLoading = false
              this.hideModal()
              this.getDetail()
              this.$store.dispatch('notification/success', 'Pembelian berhasil diperbarui.')
            }).catch(error => {
              this.saveButtonData.isLoading = false
              this.$store.dispatch('notification/error', error)
            })
          }
        })
      },
      doDelete (value) {
        this.$swal({
          title: 'Apakah anda sudah yakin?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          confirmButtonClass: 'btn btn-warning mr-3',
          cancelButtonClass: 'btn btn-default',
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.$http.delete(window.AppConfig.apiUrl + 'supplier-po-product' + '/' + value)
            .then(response => {
              this.getDetail()
              this.$store.dispatch('notification/success', 'Item berhasil dihapus.')
            })
            .catch(error => {
              this.$store.dispatch('notification/error', error)
            })
          }
        })
      },
      doUpdateOrder (ordered, supplierProductId) {
        this.isLoadingUpdateOrdered = true
        this.$http.patch(window.AppConfig.apiUrl + 'supplier-po/ordered/' + supplierProductId, {
          ordered: ordered
        })
        .then(response => {
          this.isLoadingUpdateOrdered = false
          this.getDetail()
          this.$store.dispatch('notification/success', 'Item pesanan berhasil diperbaharui.')
        })
        .catch(error => {
          this.isLoadingUpdateOrdered = false
          this.$store.dispatch('notification/error', error)
        })
      },
      getDate (value) {
        return this.$moment(value).format('DD-MM-YYYY')
      },
      getStatus (value) {
        switch (value) {
          case 0:
            return 'Dipesan'
            // eslint-disable-next-line no-unreachable
            break
          case 1:
            return 'Diterima'
            // eslint-disable-next-line no-unreachable
            break
          case 2:
            return 'Dibatalkan'
            // eslint-disable-next-line no-unreachable
            break
        }
      },
      getTotalPrice (value) {
        console.log(value)
        return value
      },
      getStatusColor (value) {
        switch (value) {
          case 0:
            return 'primary'
            // eslint-disable-next-line no-unreachable
            break
          case 1:
            return 'success'
            // eslint-disable-next-line no-unreachable
            break
          case 2:
            return 'danger'
            // eslint-disable-next-line no-unreachable
            break
        }
      },
      formatNumber (num) {
        if (num !== null) {
          return 'Rp. ' + num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ',-'
        }
      }
    }
  }
</script>

<style scooped>
  .fixed-top-selling {
    position: fixed;
    float: right !important;
    /* top: 0; */
    right: 0;
    /* left: 0; */
    width: 27%;
  }
  .fixed-top-downpayment {
    position: fixed;
    float: right !important;
    top: 48%;
    /* right: 0; */
    /* left: 0; */
    width: 37%;
  }
  .btn-remove {
    padding: 0px 3px !important;
    position: absolute;
    right: 3px;
    top: 3px;
  }
  .btn-history {
    padding: 0px 3px !important;
  }
  .font-size-12 {
    font-size: 12px !important;
  }
  .mt-4-5 {
    margin-top: 1.7rem !important;
  }
  .bubble-info {
    position: fixed;
    right: 30px;
    bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Pos/Show.vue